import React from 'react';
import { Pressable, Text, StyleSheet } from 'react-native';

import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import OPComponent from './op_component';

export default class StyledButton extends OPComponent {
  constructor(props) {
    super(props);
  }

  handlePress = () => {
    this.props.onPress && this.props.onPress(this.props.onPressValue);
  };

  render() {
    const { style, label, disabled, buttonStyles } = this.props;
    const buttonStyle = [styles.borderButton];
    const buttonTextStyle = [styles.buttonText];

    if (style === 'filled') {
      buttonStyle.push(styles.filledButton);
      buttonTextStyle.push(styles.filledButtonText);
    }
    if (disabled) {
      buttonStyle.push(styles.buttonDisabled);
      buttonTextStyle.push(styles.buttonTextDisabled);
    }
    buttonStyle.push(buttonStyles);

    return (
      <Pressable style={buttonStyle} onPress={this.handlePress} disabled={!!disabled}>
        <Text style={buttonTextStyle}>{label}</Text>
      </Pressable>
    );
  }
}

const styles = StyleSheet.create({
  borderButton: {
    marginHorizontal: 25,
    borderRadius: 4,
    borderWidth: 2,
    borderColor: COLOR.emphasis,
    paddingVertical: 15,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 15,
  },
  buttonText: {
    ...FONT.semibold,
    color: '#777777',
    fontSize: 20,
  },
  filledButton: {
    backgroundColor: COLOR.emphasis,
  },
  filledButtonText: {
    color: 'white',
  },
  buttonDisabled: {
    backgroundColor: '#cccccc',
    borderColor: '#cccccc',
  },
  buttonTextDisabled: {
    opacity: 0.8,
  },
});
